function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_91",
  "data-name": "Path 91",
  d: "M3707.723,1631.135V1797.3h-60.694c-.069,1.327-.125,2.658-.125,4a76.873,76.873,0,0,0,57.529,74.392v74.584c-.548.006-1.095.021-1.645.021a161.231,161.231,0,0,1-161.019-153h-.207V1631.135Z",
  transform: "translate(-3541.561 -1631.135)",
  fill: "#ff5252",
  opacity: 0.701
});

var SvgApostrophyFillCurved = function SvgApostrophyFillCurved(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166.162,
    height: 319.162,
    viewBox: "0 0 166.162 319.162",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgApostrophyFillCurved, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/apostrophy-fill-curved.d683e5e9.svg";
export { ForwardRef as ReactComponent };